import { RootStore } from '@/main/store/@types/store.d';

import { CRUMBS, FISKAL_MODE_ENABLED } from './getterTypes';

export const getters = {
	[CRUMBS](state: RootStore, gettersNoShadow: any) {
		return state.pageManager.pages.map(
			(pageInfo) => gettersNoShadow[`pages/${pageInfo.storeModule}/getCrumbDescription`],
		);
	},
	[FISKAL_MODE_ENABLED](state: RootStore) {
		return state.loggedUser.DmsSys.FISKMODPrp;
	},
};
